import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'mark-quote-as-accepted',
	template: require('./mark-quote-as-accepted.modal.html'),
	styles: [require('./mark-quote-as-accepted.modal.scss')]
})
export class MarkQuoteAsAcceptedModal {
	@Input('jobId') jobId: number;
	@Input('quoteId') quoteId: number;
	@Input('autoGenerateInvoice') autoGenerateInvoice: boolean;
	@Output('updateQuoteEvent')
	updateQuoteEvent: EventEmitter<any> = new EventEmitter<any>();
	disableButtons = false;

	constructor(
		private quotesDataService: QuotesDataProvider,
		private messageService: MessageService
	) {}

	markQuoteAsAccepted() {
		this.disableButtons = true;
		this.quotesDataService
			.markQuoteAsAccepted(this.jobId, this.quoteId)
			.finally(() => (this.disableButtons = false))
			.subscribe(
				() => this.successMarkAsAcceptedInvoice(),
				error =>
					this.messageService.showErrorFromBackend(
						'Oops!',
						error.error.errorMessage
					)
			);
	}

	successMarkAsAcceptedInvoice() {
		this.updateQuoteEvent.emit();
		this.messageService.showToaster('s_1', 'editQuote');
		$('#markQuoteAsAcceptedModal').modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.ts